import type { ReactStoryblokComponent } from "types/storyblok";
import { Footer, type FooterProps } from "../../globalComponents/Footer";

export const FooterAdapter = ({ blok: { footerColumns }, extraParams }: ReactStoryblokComponent<FooterProps>) => (
  <Footer footerColumns={footerColumns} hideFlagBox={extraParams?.hideFlagBox as boolean} />
);
